import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { MappingCurrentAccountBilletComponent } from './mappingCurrentAccountBillet/mappingCurrentAccountBillet.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatListModule } from '@angular/material/list';
import { MissingTranslationHandler, TranslateModule } from '@ngx-translate/core';
import { MyMissingTranslationHandler } from 'src/app/core/_config/missingTranslationHandler';
import { ComponentsModule } from 'src/app/components/components.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MappingCurrentAccountBilletListContractComponent } from './mappingCurrentAccountBillet/mappingCurrentAccountBillet-listContract/mappingCurrentAccountBillet-listContract.component';
import { MappingCurrentAccountBilletDialog } from './mappingCurrentAccountBillet/mappingCurrentAccountBillet-dialog/mappingCurrentAccountBillet-dialog.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FilterPipe } from 'src/app/pipe/Filter.pipe';

const routesManager: Routes = [
    {
        path: 'mappingBillets',
        component: MappingCurrentAccountBilletComponent,
    },
];

let MaterialModules = [
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    MatDatepickerModule,
    MatButtonModule,
    MatIconModule,
    MatPaginatorModule,
    MatSelectModule,
    MatDialogModule,
    MatSortModule,
    MatTableModule,
    MatListModule,
    MatTooltipModule,
    FormsModule,
    ReactiveFormsModule,
];

@NgModule({
    imports: [
        CommonModule,
        ComponentsModule,
        NgbModule,
        TranslateModule.forChild({
            missingTranslationHandler: { provide: MissingTranslationHandler, useClass: MyMissingTranslationHandler },
            useDefaultLang: false,
        }),
        RouterModule.forChild(routesManager),
        MaterialModules,
    ],
    declarations: [
        MappingCurrentAccountBilletComponent,
        MappingCurrentAccountBilletListContractComponent,
        MappingCurrentAccountBilletDialog,
        FilterPipe,
    ],
    entryComponents: [
        MappingCurrentAccountBilletComponent,
        MappingCurrentAccountBilletListContractComponent,
        MappingCurrentAccountBilletDialog,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ManagerModule {}
